import { useSelector } from 'react-redux'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

const ProtectLoggedIn = () => {
  const user = useSelector((state) => state.user.user)
  const location = useLocation()

  return user?.token ? <Outlet /> : <Navigate to="/" state={{ from: location }} replace />
}

export default ProtectLoggedIn
